import React, { FC } from 'react';

import SunshineCard from 'components/_core/SunshineCard';

import useDashboardNeedsEmptyState from '../../hooks/useDashboardNeedsEmptyState';
import { TransactionsEmptyState } from './components/EmptyStates';
import {
  ContextMenu,
  TransactionAggregationItem,
  TransactionAggregationTableItem,
} from './components/TransactionAggregationItem';
import { StatIndicatorMode } from './components/TransactionAggregationItem/components/StatIndicator';

export type TransactionAggregationItemWithId =
  TransactionAggregationTableItem & {
    id: string;
  };

export const TransactionAggregationTable: FC<{
  items: TransactionAggregationItemWithId[];
  mode: StatIndicatorMode;
  onContextMenuClicked?: (args: {
    contextMenuId: string;
    itemId: string;
  }) => void;
  contextMenu?: ContextMenu;
  colorSchema?: 'arrow-normal' | 'arrow-reversed';
  emptyStateComponent?: FC;
}> = ({
  colorSchema = 'arrow-normal',
  contextMenu,
  emptyStateComponent,
  items,
  mode,
  onContextMenuClicked,
}) => {
  const needsEmptyState = useDashboardNeedsEmptyState({
    payin: items?.map((item) => {
      return {
        newValue: item.currentValue || 0,
        oldValue: (item.currentValue || 0) + (item.delta || 0),
      };
    }),
  });

  if (!items?.length || needsEmptyState) {
    const EmptyState = emptyStateComponent || TransactionsEmptyState;
    return <EmptyState />;
  }

  return (
    <SunshineCard.Group>
      {items.map((item) => {
        return (
          <TransactionAggregationItem
            colorSchema={colorSchema}
            contextMenu={contextMenu}
            key={item.id}
            mode={mode}
            onContextMenuClicked={(contextMenuId) =>
              onContextMenuClicked?.({ contextMenuId, itemId: item.id })
            }
            {...item}
          />
        );
      })}
    </SunshineCard.Group>
  );
};
